module.exports = __webpack_public_path__ + "img/play-button-icon.bb60d4ce.svg";